import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    container: {
        display: 'flex',
        flexDirection: 'column',
        background: '#FFFFFF',
        padding: '24px',
        boxSizing: 'border-box',
        height: '100%'
    },
    wrapper: {
        flex: 1,
        overflowY: 'auto',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    },
    menuList: {
        display: 'flex',
        flexDirection: 'column'
    },
    menuListAdaptive: {
        '@media (max-width: 960px)': {
            alignItems: 'center'
        }
    },
    searchBarRoot: {
        maxWidth: 300,
        marginBottom: 16
    },
    divider: {
        marginTop: 4,
        marginBottom: 4,
        borderColor: '#ECECEC'
    }
});
